// import React, { Suspense, lazy } from 'react'
import React from 'react'

import ErrorWrapper from './wrappers/error'

// Pages
// const Error = lazy(() => import('../pages/Error'))
import Error from '../pages/Error'

class ErrorRoutes extends React.Component {
    _isMounted = false

    state = {}

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    render() {
        const { location } = this.props

        return (
            // <Suspense fallback={<></>}>
            <ErrorWrapper location={location} path="/error" component={Error} />
            // </Suspense>
        )
    }
}

export default ErrorRoutes
